import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import {
  ConsultarSubcuentasCoGaRequest,
  ConsultarSubcuentasCoGaJsonParametros
} from '../../models/cotizador-contratante/consultar-subcuentas-co-ga/request/consultar-subcuentas-c-ga-request.model';
import { ConsultarSubcuentasCoGaResponse } from '../../models/cotizador-contratante/consultar-subcuentas-co-ga/response/consultar-subcuentas-c-ga-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarSubcuentasColectivosGruposService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CONSULTA_ACTIVO_AC}`;

  constructor(private httpClient: HttpClient) { }

  consultarSubcuentasColectivosGrupos(params: ConsultarSubcuentasCoGaJsonParametros): Observable<ConsultarSubcuentasCoGaResponse> {
    const request: ConsultarSubcuentasCoGaRequest = {
      nombreClave: 'getconsultacolectivoac',
      jsonParametros: JSON.stringify(params)
    };

    return this.httpClient.post<ConsultarSubcuentasCoGaResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarSubcuentasColectivosGrupos: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar subcuentas colectivos/grupos'));
      })
    );
  }
}
